/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { UNMAPPED_AFNO } from "~/features/promoTools/constants";
import { GetPromoToolSitesResponse, PromoToolsSite } from "~/features/promoTools/types";

interface TransformGetPromoToolsSites {
  toSites: (data: GetPromoToolSitesResponse) => PromoToolsSite[];
}

const transformGetPromoToolsSites: TransformGetPromoToolsSites = {
  toSites: (data) =>
    data.result.map((site) => ({
      ...site,
      unmappedIds: site.afnoDetails
        .filter((detail) => detail.mapped === UNMAPPED_AFNO)
        .map((detail) => String(detail.trackingId)),
    })),
};

export default transformGetPromoToolsSites;
